import styled from 'styled-components'
import { bp } from 'lib/core/resources/helpers/styled'

export const Container = styled.div`
  max-width: ${props => props.theme.maxWidth};
  margin: 0 auto;
  padding: 20px 20px;

  > p > img {
    display: block;
    width: auto;
    max-width: 100%;
  }
`

export const Layout = styled.div`
  display: grid;
  grid-template-columns: 18em auto;
  grid-gap: 20px;
  margin: 20px 0;
  ${bp('lg')`
    grid-template-columns: auto;
  `}

  > div {
    align-self: start;

    &:first-child {
      ${bp('lg')`
        display: none;
      `}
    }
  }
`
